module.exports = __webpack_public_path__ + "static/flags/RM-7193c3a8c2ceb1b0bc029d6098c37f27.gif";